import {
    faFileAlt,
    faFileExcel,
    faFileImage,
    faFilePdf,
    faFilePowerpoint,
    faFileWord
} from "@fortawesome/pro-regular-svg-icons";
import {faDownload, faFile} from "@fortawesome/pro-solid-svg-icons";
import {GetFile} from "./request";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

export function getFileIcon(mime) {
    switch (true) {
        case mime.includes("word"):
            return faFileWord;
        case mime.includes("excel"):
            return faFileExcel;
        case mime.includes("powerpoint"):
            return faFilePowerpoint;
        case mime.includes("pdf"):
            return faFilePdf;
        case mime.includes("image"):
            return faFileImage;
        case mime.includes("text"):
            return faFileAlt;
        default:
            return faFile;
    }
}

export async function getFile(inscriptionID, filename) {
    await GetFile(`/v1/files/printDocument/${inscriptionID}/${filename}`, {}, "Téléchargement en cours...", {
        render: (
            <>
                <FontAwesomeIcon className="mr-2" icon={faDownload}/>
                Document téléchargé !
            </>
        )
    }, {
        render: (
            <>
                <FontAwesomeIcon className="mr-2" icon={faDownload}/>
                Erreur lors du téléchargement...
            </>
        )
    }, false);
}

export function findLatestResultat(item) {
    const {
        ProgrammeEtudiantReportResultat,
        ProgrammeEtudiantTransfertResultat,
        ProgrammeEtudiantResultatFinal,
        ResultatEtudiantInscritS3,
        ResultatEtudiantResultatS3,
        ResultatEtudiantInscritS2,
        ResultatEtudiantResultatS2,
        ResultatEtudiantInscritS1,
        ResultatEtudiantResultatS1,
        ResultatEtudiantResultatPartiel,
        Diffusion,
        SessionNumero
    } = item;

    // Report or Transfer
    if(ProgrammeEtudiantReportResultat || ProgrammeEtudiantTransfertResultat) {
        return ProgrammeEtudiantResultatFinal?.toString().padStart(2, "0") ?? null;
    }

    // Resultat s3
    if(ResultatEtudiantInscritS3 && ((Diffusion && SessionNumero === 3) || ResultatEtudiantResultatS3 !== null)) {
        return ResultatEtudiantResultatS3?.toString().padStart(2, "0") ?? '--';
    }

    // Resultat s2
    if(ResultatEtudiantInscritS2 && ((Diffusion && SessionNumero === 2) || ResultatEtudiantResultatS2 !== null)) {
        return ResultatEtudiantResultatS2?.toString().padStart(2, "0") ?? '--';
    }

    // Resultat s1
    if(ResultatEtudiantInscritS1 && ((Diffusion && SessionNumero === 1) || ResultatEtudiantResultatS1 !== null)) {
        return ResultatEtudiantResultatS1?.toString().padStart(2, "0") ?? '--';
    }

    // Resultat Partiel
    if(ResultatEtudiantResultatPartiel !== null) {
        return 'P: ' + ResultatEtudiantResultatPartiel.toString().padStart(2, "0");
    }

    // No result
    return null;
}